import React from "react";
import {Drawer, Form, Input, Row, Col, Select, Button, Switch} from "antd";
import {compose} from "recompose";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {bindActionCreators} from "redux";
import * as CustomerActions from '../../../reducers/customer';
import PropTypes from "prop-types"

class CustomerCreationDrawer extends React.Component {

    static propTypes = {
        createCustomer: PropTypes.func.isRequired,
        updateCustomer: PropTypes.func.isRequired,
    };

    render() {
        const {visible, toggleVisibility, form: {getFieldDecorator}} = this.props;

        const onFinish = (event) => {
            this.props.form.validateFields((errors, values) => {
                if(!errors) {
                    this.props.createCustomer(values);
                    this.props.toggleVisibility();
                }
            })
        }

        return <Drawer title="New Customer" width={900} placement="right" visible={visible} style={{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: 53,
        }} onClose={toggleVisibility}>
            <Form onSubmit={onFinish}>
                <Row gutter={22}>
                    <Col span={22}>
                        <Form.Item label="Description">
                            <p>In aPureBase a customer, such as GSK, is divided into country specific customer instances. GSK Nordic therefore consists of GSK Denmark, GSK Sweden, GSK Finland and GSK Norway. Please use this structure when creating customers.</p>
                            <p>Name: A good name is the company name, followed by the country name. Example: GSK Pharma Denmark</p>
                            <p>Country: ISO2 code for the country. Denmark = DK, Sweden = SE etc. (https://www.iban.com/country-codes)</p>
                            <p>HQ name: GSK Pharma Denmark -> GSK Pharma</p>
                            <p>Code: Unique code for the customer. Typical country code + initials. Example: DK.GSKPHARMA</p>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Name">
                            {getFieldDecorator('name', {
                                rules: [{required: true, message: 'Please enter a client name'}],
                            })(<Input placeholder="Please enter a client name"/>)}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Country">
                            {getFieldDecorator('countryId', {
                                rules: [{required: true, message: 'Please enter ISO2 country code'}],
                            })(<Input placeholder="ISO2 country code"/>)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="HQ name">
                            {getFieldDecorator('callName', {
                                rules: [{required: true, message: 'Please enter HQ name for the customer'}],
                            })(<Input placeholder="Please enter HQ name for the customer"/>)}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Code">
                            {getFieldDecorator('code', {
                                rules: [{required: true, message: 'Please enter a customer unique code'}],
                            })(<Input placeholder="Please enter a customer unique code"/>)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Key Account Manager">
                            {getFieldDecorator('kam', {
                                rules: [{required: true, message: 'Please enter the 3 letter KAM initials'}],
                            })(<Input placeholder="Please enter the 3 letter KAM initials"/>)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Include in reports">
                            {getFieldDecorator('includeInReports', {
                                valuePropName: 'checked', initialValue: true
                            })(<Switch/>)}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Active">
                            {getFieldDecorator('active', {
                                valuePropName: 'checked', initialValue: true
                            })(<Switch/>)}
                        </Form.Item>
                    </Col>
                </Row>
                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    <Button
                        style={{
                            marginRight: 8,
                        }}
                        onClick={toggleVisibility}
                    >
                        Cancel
                    </Button>
                    <Button htmlType="submit" type="primary">Submit</Button>
                </div>
            </Form>
        </Drawer>
    }

}

const mapStateToProps = state => ({
    customers: state.customer.customers,
    fetchingCustomers: state.customer.fetchingCustomers
});

const mapDispatchToProps = dispatch => ({
    createCustomer: bindActionCreators(CustomerActions, dispatch).createCustomer,
    updateCustomer: bindActionCreators(CustomerActions, dispatch).updateCustomer,
});

export default compose(
    withRouter,
    Form.create(),
    connect(mapStateToProps, mapDispatchToProps),
)(CustomerCreationDrawer);


// WEBPACK FOOTER //
// ./src/js/browse/customer/create/CustomerCreationDrawer.js